import './InverterBox.css';

export default function InverterBox({ invdata, plotdata, onClick }) {

    const ReadTags_Thounsand = (data, key, digit) => {
        const value = data?.[key];
        if (value === undefined || value === null) {
            return "-";
        }
        return value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    const getInverterIcon = (data) => {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <span className='tagalarm alarming'>Unknown Logger State</span>
        }
        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                if (data.fault_code === 0) {
                    return <span className='tagalarm normal'>Online</span>
                }
                return <span className='tagalarm alarming'>Fault</span>
            }
            return <span className='tagalarm alarming'>Device Offline</span>
        }
        return <span className='tagalarm alarming'>Logger Offline</span>
    }


    const getFaultIcon = (data) => {
        const value = data?.fault_code_text;
        if (value === undefined || value === null) {
            return null
        }
        if (data.fault_code !== 0 || (data.fault_code_text !== "0" && data.fault_code_text !== "")) {
            return <span className='tagalarm alarming'>Fault</span>
        }
        return null
    }

    const getShutdownIcon = (data) => {
        const value = data?.is_run_shutdown;
        if (value === undefined || value === null) {
            return null
        }
        if (!data.is_run_shutdown) {
            return <span className='tagalarm alarming'>SHD</span>
        }
        return null
    }

    const getPLimitIcon = (data) => {
        const value = data?.inverter_state;
        if (value === undefined || value === null) {
            return null
        }
        if (data.inverter_state === 513) {
            return <span className='tagalarm warning-orange'>P Limit</span>
        }
        return null
    }

    return (
        <div className={"inverter-box font-poppins inv-line-" + plotdata.lineside} id={plotdata.id + '-info'} style={{ left: plotdata.x + "px", top: plotdata.y + "px", "--lenx": plotdata.linelen + "px", "--marginx": plotdata.linemargin + "px" }} onClick={() => onClick("INV-" + String(plotdata.inv).padStart(2, '0'))}>
            <div className="inverter-box-header">{"INV-" + String(plotdata.inv).padStart(2, '0')} {getInverterIcon(invdata)} {getFaultIcon(invdata)} {getShutdownIcon(invdata)} {getPLimitIcon(invdata)}</div>
            <div className="inverter-box-table">
                <div className="inverter-box-rows">
                    <div className="inverter-box-cell px-1">P.Active</div>
                    <div className="inverter-box-cell numberright">{ReadTags_Thounsand(invdata, 'ac_power_active_total', 2)}</div>
                    <div className="inverter-box-cell measunits">kW</div>
                </div>
                {
                    plotdata.day_total !== "n" ?
                        <>
                            <div className="inverter-box-rows">
                                <div className="inverter-box-cell px-1">Day</div>
                                <div className="inverter-box-cell numberright">{ReadTags_Thounsand(invdata, 'energy_active_total_today', 2)}</div>
                                <div className="inverter-box-cell measunits">kWh</div>
                            </div>
                            <div className="inverter-box-rows">
                                <div className="inverter-box-cell px-1">Total</div>
                                <div className="inverter-box-cell numberright">{ReadTags_Thounsand(invdata, 'energy_active_total', 2)}</div>
                                <div className="inverter-box-cell measunits">kWh</div>
                            </div>
                        </>
                        :
                        null
                }
            </div>
        </div>
    )
}

